import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import Alert from "@mui/material/Alert";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { useAuth } from "context/AuthContext";
const curved9 = "/images/signInGround.JPG";

function SignIn() {
  const { login } = useAuth();
  const navigate  = useNavigate();

  const [email,       setEmail]       = useState("");
  const [password,    setPassword]    = useState("");
  const [rememberMe,  setRememberMe]  = useState(true);
  const [error,       setError]       = useState("");
  const [loading,     setLoading]     = useState(false);

  const getErrorMessage = (err) => {
    const status = err?.status;
    const detail = err?.errors?.detail ?? "";
    const message = err?.message ?? "";

    if (detail.toLowerCase().includes("locked")) {
      return "Your account has been temporarily locked after too many failed attempts. Please try again in 30 minutes or contact your administrator.";
    }
    if (detail.toLowerCase().includes("invalid credentials") || status === 401) {
      return "Incorrect email or password. Please check your credentials and try again.";
    }
    if (status === 404 || detail.toLowerCase().includes("not found")) {
      return "No account found with this email address. Please check and try again.";
    }
    if (status === 403) {
      return "Your account has been deactivated. Please contact your administrator.";
    }
    if (status === 429) {
      return "Too many login attempts. Please wait a few minutes before trying again.";
    }
    if (status >= 500) {
      return "Service temporarily unavailable. Please try again shortly.";
    }
    if (message.toLowerCase().includes("network") || !status) {
      return "Unable to connect to the server. Please check your internet connection.";
    }
    if (detail) return detail;
    return "Login failed. Please try again.";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/academy/dashboard", { replace: true });
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <CoverLayout
      title="ClubOS"
      description=""
      image={curved9}
    >
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        {error && (
          <SoftBox mb={2}>
            <Alert severity="error" sx={{ fontSize: "0.8rem" }}>{error}</Alert>
          </SoftBox>
        )}

        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="body2" fontWeight="bold" color="white">
              Email Id
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="email"
            placeholder="Email Id"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </SoftBox>

        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="body2" fontWeight="bold" color="white">
              Password
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </SoftBox>

        <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} />
          <SoftTypography
            variant="body2"
            fontWeight="regular"
            onClick={() => setRememberMe(!rememberMe)}
            sx={{ cursor: "pointer", userSelect: "none" }}
            color="white"
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox>

        <SoftBox mt={4} mb={1}>
          <SoftButton
            type="submit"
            fullWidth
            disabled={loading}
            sx={{
              background: "linear-gradient(135deg, #000000 0%, #333333 100%)",
              color: "#ffffff !important",
              fontWeight: "900 !important",
              fontSize: "1.1rem",
              border: "2px solid #444444",
              "& span": {
                color: "#ffffff !important",
                fontWeight: "900 !important",
              },
              "&:hover": {
                background: "linear-gradient(135deg, #1a1a1a 0%, #444444 100%)",
                borderColor: "#555555",
              },
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </SoftButton>
        </SoftBox>

        <SoftBox mt={3} sx={{ textAlign: "center", borderTop: "1px solid rgba(255,255,255,0.1)", pt: 2, display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
          <span style={{ fontSize: "20px" }}>⚡</span>
          <SoftTypography variant="body2" color="white" fontWeight="regular" sx={{ opacity: 0.8 }}>
            Powered by <strong>AthElite Sports Management</strong>
          </SoftTypography>
        </SoftBox>

        {/* <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t have an account?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Sign up
            </SoftTypography>
          </SoftTypography>
        </SoftBox> */}
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
